export const isRollupApplicable = (dataType) =>{
    const rollUpAllowedDataTypes = ["date", "number"];
    return rollUpAllowedDataTypes.includes(dataType);
}

export function clearExistingMdvDataInSheet(props, setExistingMdvDataInSheet) {
    if (props?.existingMdvDataInSheet && props.existingMdvDataInSheet.length > 0) {
        setExistingMdvDataInSheet([]);
    }
  }